import { create } from "zustand";
import type { TarotCard } from "./types";

type CardStore = {
  shuffledCards: TarotCard[];
  setShuffledCards: (cards: TarotCard[]) => void;
  selectedCards: TarotCard[];
  setSelectedCards: (cards: TarotCard[]) => void;
  toggleSelectedCard: (card: TarotCard | TarotCard[]) => void;
  clearSelectedCards: () => void;
  isSelectionComplete: boolean;
  setSelectionComplete: (isComplete: boolean) => void;
};

const useCardStore = create<CardStore>()((set, get) => ({
  shuffledCards: [],
  setShuffledCards: (shuffledCards) => set(() => ({ shuffledCards })),
  selectedCards: [],
  setSelectedCards: (selectedCards) => set(() => ({ selectedCards })),
  toggleSelectedCard: (card) => {
    const { selectedCards } = get();

    if (Array.isArray(card)) {
      set({
        selectedCards: [...selectedCards, ...card],
      });
      return;
    }

    // Проверяем, есть ли карта в массиве
    const exists = selectedCards.some((c) => c.img_src === card.img_src);

    if (exists) {
      // Если есть — удаляем
      set({
        selectedCards: selectedCards.filter((c) => c.img_src !== card.img_src),
      });
    } else {
      // Если нет — добавляем
      set({
        selectedCards: [...selectedCards, card],
      });
    }
  },
  clearSelectedCards: () => set(() => ({ selectedCards: [] })),
  isSelectionComplete: false,
  setSelectionComplete: (isComplete) =>
    set(() => ({ isSelectionComplete: isComplete })),
}));

export default useCardStore;
